import "core-js/modules/es.number.constructor.js";
export default {
  props: {
    text: {
      type: String,
      default: 'APP 内打开'
    },
    deviceHeight: {
      type: Number,
      default: 0
    }
  },
  components: {},
  data: function data() {
    return {
      startPageX: 0,
      startPageY: 0,
      X: 0,
      Y: 0,
      availWidth: document.documentElement.clientWidth,
      availHeight: document.documentElement.clientHeight,
      clientWidth: 0,
      clientHeight: 0,
      safeBottomHeight: 0
    };
  },
  computed: {
    position: function position() {
      var maxWidth = this.availWidth - this.clientWidth;
      var maxHeight = this.deviceHeight - this.clientHeight - this.safeBottomHeight;
      var X = this.startPageX + this.X;
      var Y = this.startPageY + this.Y;
      var left = X < 0 ? 0 : X > maxWidth ? maxWidth : X;
      var top = Y < 0 ? 0 : Y > maxHeight ? maxHeight : Y;
      return {
        left: left,
        top: top
      };
    },
    styles: function styles() {
      var left = this.position.left + 'px';
      var top = this.position.top + 'px';
      return {
        left: left,
        top: top
      };
    }
  },
  methods: {
    handleTouchEnd: function handleTouchEnd() {
      this.startPageX = this.startPageX + this.X;
      this.startPageY = this.startPageY + this.Y;
      this.X = 0;
      this.Y = 0;
    },
    handleTouchMove: function handleTouchMove(e) {
      this.X = e.X;
      this.Y = e.Y;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.safeBottomHeight = this.$refs.bottom && this.$refs.bottom.offsetHeight;
    this.clientWidth = this.$el.clientWidth;
    this.clientHeight = this.$el.clientHeight;
    this.startPageX = this.availWidth / 2 - this.clientWidth / 2;
    console.log('this.clientHeight', this.clientHeight);
    console.log('this.safeBottomHeight', this.safeBottomHeight);
    this.startPageY = this.deviceHeight - this.clientHeight - 70;
  },
  beforeUnmount: function beforeUnmount() {},
  watch: {}
};